import {
    PARTNER_COMPLETE_STEP,
    PARTNER_GIFT_INFO_STEP,
    PARTNER_PAYMENT_STEP,
} from '@/src/modules/partners/constants'
import PartnerStepHeader from '@/src/modules/partners/PartnerStepHeader'
import { TPartnerPayload } from '@/src/modules/partners/types'

type TStepHeaderProps = {
    partnerData: TPartnerPayload
    currentStep: number
    showCart: boolean
    showMobileNav?: boolean
}

const DefaultPartnerStepHeader = ({
    partnerData,
    currentStep,
    showCart,
    showMobileNav = true,
}: TStepHeaderProps) => {
    return (
        <PartnerStepHeader
            currentStep={currentStep}
            partnerData={partnerData}
            steps={[
                { text: PARTNER_GIFT_INFO_STEP },
                { text: PARTNER_PAYMENT_STEP },
                { text: PARTNER_COMPLETE_STEP },
            ]}
            showCart={showCart}
            showMobileNav={showMobileNav}
        />
    )
}

export default DefaultPartnerStepHeader
